export enum TypeOfSupply{
    CapitalGoods= "Capital Goods",
    Goods="Goods",
    Services="Services"

}